/**
 * Module dependencies.
 */

/**
 * Sanitize HTML to prevent XSS attacks.
 * This function escapes potentially dangerous HTML characters.
 */

export function sanitizeHtml(input: string): string {
  if (!input) {
    return '';
  }

  return String(input)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;')
    .replace(/\//g, '&#x2F;');
}

/**
 * Sanitize user input for safe display.
 * Removes any HTML tags and escapes special characters.
 */

export function sanitizeInput(input: string): string {
  if (!input) {
    return '';
  }

  // Remove any HTML tags
  const withoutTags = input.replace(/<[^>]*>/g, '');

  // Escape special characters
  return sanitizeHtml(withoutTags);
}

/**
 * Export utilities.
 */

const sanitizeUtils = {
  sanitizeHtml,
  sanitizeInput
};

export default sanitizeUtils;


